import { Card, Box } from "@mui/material";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { httpRequest } from "src/services/httpRequest";
import FormikForm from "src/ui-component/FormikFormLibrary";
import { Fields } from "src/ui-component/FormikFormLibrary/FormikTypes";

type AddNewPermitProps = {
    setPermitAction: Dispatch<SetStateAction<string>>;
    permitAction: any;
    handleApiCall: () => void;
};

const AddPermit: React.FC<AddNewPermitProps> = ({
    setPermitAction,
    permitAction,
    handleApiCall
}) => {

    const [allDepartmentData, setAllDepartmentData] = useState([]);
    const [filteredDepartmentName, setFilteredDepartmentName] = useState([])

    useEffect(() => {
        const getAllDepartments = async () => {
            const response = await httpRequest('GET', '/townships/departments')
            const departments = response?.data?.Data
            setAllDepartmentData(departments)
            const departmentData = departments.map(item => item.DepartmentName)
            setFilteredDepartmentName(departmentData)
        }
        getAllDepartments()
    }, [])

    // Form fields using Formik
    const allFields: Fields[] = [
        {
            fieldName: 'DepartmentName',
            fieldLabel: 'Department Name',
            fieldType: 'select',
            options: filteredDepartmentName,
            required: true,
            disabled: permitAction !== 'Add',
            heading: 'Department Details',
            initialValue: permitAction?.Departments?.DepartmentName || '',
        },
        {
            fieldName: 'PermitName',
            fieldLabel: 'Permit Name',
            fieldType: 'text',
            required: true,
            heading: 'Permit Details',
            disabled: permitAction !== 'Add',
            initialValue: permitAction?.PermitName || ''
        },
        {
            fieldName: 'PermitStatus',
            fieldLabel: 'Permit Status',
            fieldType: 'select',
            options: ['Active', 'InActive'],
            required: true,
            initialValue: permitAction?.Status || ''
        },
        {
            fieldName: 'PermitDescription',
            fieldLabel: 'Permit Description',
            fieldType: 'note',
            required: true,
            placeHolder: 'Type your text here (255 characters max)',
            initialValue: permitAction?.Description || ''
        },
        {
            fieldName: 'SubscriptionFeeYearly',
            fieldLabel: 'Subscription Fee (Yearly)',
            fieldType: 'number',
            required: true,
            heading: 'Subscription Fee Details',
            initialValue: permitAction?.SubscriptionFee?.Yearly || 0
        },
        {
            fieldName: 'SubscriptionFeeMonthly',
            fieldLabel: 'Subscription Fee (Monthly)',
            fieldType: 'number',
            required: true,
            initialValue: permitAction?.SubscriptionFee?.Monthly || 0
        },
    ]

    // Handle form submit
    async function handleSubmit(value: any) {
        let payload = {}
        if (permitAction === 'Add') {
            payload = {
                PermitName: value?.PermitName,
                Department: {
                    DepartmentID: (allDepartmentData.find(dep => dep.DepartmentName === value?.DepartmentName) || {}).DepartmentID || null,
                    DepartmentName: value?.DepartmentName
                },
                SubscriptionFee: {
                    Yearly: Number(value?.SubscriptionFeeYearly),
                    Monthly: Number(value?.SubscriptionFeeMonthly)
                },
                Status: value?.PermitStatus,
                Description: value?.PermitDescription
            }
        } else {
            payload = {
                PermitID: permitAction?.PermitID,
                SubscriptionFee: {
                    Yearly: Number(value?.SubscriptionFeeYearly),
                    Monthly: Number(value?.SubscriptionFeeMonthly)
                },
                Status: value?.PermitStatus,
                ChangeReason: 'Admin',
                Description: value?.PermitDescription
            }
        }

        try {
            const response = await httpRequest(
                `${permitAction === 'Add' ? 'POST' : 'PATCH'}`,
                `${permitAction === 'Add'
                    ? `/townships/add_permit`
                    : `/townships/update_permit`
                }`,
                payload
            );

            if (response?.status === 'success') {
                toast.success(
                    `Township ${permitAction === 'Add' ? 'added' : 'details updated'
                    } successfully!`
                );
                setPermitAction('');
                handleApiCall()
            } else if (response?.type === 'NETWORK_ERROR') {
                toast.error('Network error. Please try again.');
            } else {
                toast.error(response?.message || 'Failed to add township.');
            }
        } catch (error) {
            toast.error('Failed to add township. Please try again.');
        }
    }

    // Handle cancel button
    function handleCancel() {
        setPermitAction('')
    }

    return (
        <Card>
            <Box m={3}>
                <FormikForm
                    allFields={allFields}
                    buttonTitle={['Cancel', 'Save']}
                    fullScreen={false}
                    isEditModel={false}
                    content={false}
                    buttonPlacement={'right'}
                    formMethod={handleSubmit}
                    handleOtherButton={handleCancel}
                />
            </Box>
        </Card>
    );
}

export default AddPermit